import { MessageCircle } from "lucide-react";
import SocialIcons from "./SocialIcons";
import { PhoneBadge, WhatsAppBadge, MailBadge } from "./ContactIcons";
import Logo from "./Logo";
import Reveal from "./Reveal";
import { Link } from "react-router-dom";
import { OFFICE, waLink, CATEGORIES, LOCATIONS } from "../data/office";

export default function Footer() {
  return (
    <footer id="contato" data-testid="footer-section" className="grain relative overflow-hidden bg-navy-950">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-gold-500/10 blur-[120px]" />

      <div className="relative z-10 mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
        <Reveal className="mx-auto max-w-3xl text-center">
          <p className="font-mono-meta text-[11px] uppercase tracking-[0.35em] text-gold-400">
            Vamos conversar
          </p>
          <h2 className="font-display mt-5 text-4xl font-medium leading-tight text-cream sm:text-5xl lg:text-6xl">
            Todo caso começa com uma <em className="gold-text">conversa</em>.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-mist">
            Envie uma mensagem e agende sua consulta. Atendimento claro, sigiloso e sem compromisso na primeira análise.
          </p>
          <a
            data-testid="footer-cta-whatsapp"
            href={waLink(null)}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-9 inline-flex items-center gap-3 rounded-full bg-gold-500 px-9 py-4 text-sm font-bold uppercase tracking-widest text-navy-950 transition-transform duration-300 hover:scale-[1.03] hover:bg-gold-400"
          >
            <MessageCircle className="h-4 w-4" />
            Falar no WhatsApp
          </a>
        </Reveal>

        <div className="mt-20 h-px w-full gold-rule opacity-30" />

        <div className="mt-14 grid grid-cols-1 gap-12 md:grid-cols-3">
          <div>
            <Logo imgClassName="h-20 w-auto" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-mist">
              {OFFICE.name} — atendimento humanizado, estratégico e dedicado à defesa dos direitos de nossos clientes.
            </p>
            <SocialIcons className="mt-6" />
            <p className="font-mono-meta mt-4 text-[11px] uppercase tracking-[0.25em] text-gold-400">
              {OFFICE.oab}
            </p>
          </div>
          <div data-testid="footer-areas">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-cream">Áreas de atuação</p>
            <ul className="mt-5 space-y-2.5">
              {CATEGORIES.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/areas/${c.slug}`}
                    data-testid={`footer-area-${c.slug}`}
                    className="text-sm text-mist transition-colors hover:text-gold-400"
                  >
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div data-testid="footer-contact">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-cream">Contato</p>
            <ul className="mt-5 space-y-2.5 text-sm text-mist">
              <li>
                <a data-testid="footer-phone" href={`tel:+${OFFICE.phone}`} className="flex items-center gap-3 transition-colors hover:text-gold-400">
                  <PhoneBadge />
                  <span>Ligação: {OFFICE.phonePretty}</span>
                </a>
              </li>
              <li>
                <a data-testid="footer-whatsapp" href={waLink(null)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 transition-colors hover:text-gold-400">
                  <WhatsAppBadge />
                  <span>WhatsApp: {OFFICE.whatsappPretty}<span className="block text-[11px] text-mist/70">Atendimento comercial · somente mensagens</span></span>
                </a>
              </li>
              <li>
                <a data-testid="footer-email" href={`mailto:${OFFICE.email}`} className="flex items-center gap-3 break-all transition-colors hover:text-gold-400">
                  <MailBadge />
                  <span>{OFFICE.email}</span>
                </a>
              </li>
              {LOCATIONS.map((l) => (
                <li key={l.label}>{l.label}: {l.address}</li>
              ))}
              <li>{OFFICE.hours}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-navy-700 pt-8 text-xs text-mist/60 sm:flex-row">
          <p>
            © {new Date().getFullYear()} {OFFICE.name}. Todos os direitos reservados.
          </p>
          <p className="flex flex-col items-center gap-2 sm:flex-row sm:gap-5">
            <Link to="/privacidade" data-testid="footer-privacy" className="underline-offset-4 transition-colors hover:text-gold-400 hover:underline">
              Política de Privacidade
            </Link>
            <span className="font-mono-meta uppercase tracking-[0.2em]">
              Este site não constitui consultoria jurídica.
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}
